export default ({ request }) => ({
    ecomAmzPriceControlListApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/list',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlDetailApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/detail',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlSaveApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/save',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlDelApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/del',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlConfirmApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/confirm',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlDetailListApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/detail/list',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlDetailSaveApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/detail/save',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlDetailDetailApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/detail/detail',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlDetailDelApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/detail/del',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlDetailMarketListApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/detail/market/list',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlDetailMarketSaveApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/detail/market/save',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlDetailMarketDetailApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/detail/market/detail',
        method: 'post',
        data,
      })
    },
    ecomAmzPriceControlDetailMarketDelApi(data = {}) {
      return request({
        url: '/ecom/amz/price/control/detail/market/del',
        method: 'post',
        data,
      })
    },
    masterFormulaCalculateApi(data = {}) {
      return request({
        url: '/master/formula/calculate',
        method: 'post',
        data,
      })
    },
  })
  